var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.initialLoadFinished
    ? _c(
        "div",
        [
          _c("MasqueradingBanner"),
          _vm._v(" "),
          _vm.isRegisterPage
            ? [
                _vm.isRegisterPage
                  ? _c("div", [_c("router-view")], 1)
                  : _vm._e(),
              ]
            : [
                _vm.isLoggedIn || _vm.isSignaturePage || _vm.isContractDisplay
                  ? _c("div", [
                      _c("div", { staticClass: "bg-black text-white py-5" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-wrap items-end max-w-2xl m-auto px-5 pb-5",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "w-full md:w-1/2 mt-5" },
                              [
                                _c("router-link", { attrs: { to: _vm.home } }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "221",
                                        height: "43",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                      },
                                    },
                                    [
                                      _c("defs", [
                                        _c("path", {
                                          attrs: {
                                            id: "a",
                                            d: "M0 34.733h28.385V.003H0z",
                                          },
                                        }),
                                      ]),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            fill: "none",
                                            "fill-rule": "evenodd",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                transform: "translate(0 7.888)",
                                              },
                                            },
                                            [
                                              _c(
                                                "mask",
                                                {
                                                  attrs: {
                                                    id: "b",
                                                    fill: "#fff",
                                                  },
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xlink:href": "#a",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c("path", {
                                                attrs: {
                                                  d: "M21.67 25.793l-4.833 3.42.008-3.432 4.825.012zM3.502 3.523l18.885.043-8.193 5.736c-.481.337-.77.892-.77 1.487l-.027 11.47-9.937-.023.042-18.713zm13.373 8.169l8.038-5.63-.037 16.223-8.024-.018.023-10.575zm11.51-10.297A1.322 1.322 0 0 0 27.08.061L1.364.002A1.322 1.322 0 0 0 .05 1.332l-.05 23.08a1.322 1.322 0 0 0 1.306 1.334l12.083.028-.017 7.626a1.32 1.32 0 0 0 1.304 1.333c.267 0 .525-.082.747-.238l12.322-8.72c.36-.255.579-.676.58-1.124v-.092c.003-.028.01-.054.01-.083l.05-23.08z",
                                                  fill: "#FEFEFE",
                                                  mask: "url(#b)",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("path", {
                                            attrs: {
                                              d: "M53.212 10.57c-.019 0-.036 0-.055.004-.327-.03-.665-.056-1.032-.056-1.706 0-4.328.438-5.793 2.689v-.002a.183.183 0 0 1-.152.073.18.18 0 0 1-.179-.181l-.002.001v-2.149a.263.263 0 0 0-.262-.253H40.591a.263.263 0 0 0-.271.25l-.001.003v20.337l.003.003v.003a.26.26 0 0 0 .324.255h5.24a.263.263 0 0 0 .326-.246l-.002-.024v-9.254c0-4.5 2.552-5.9 5.537-5.9.436 0 .896.028 1.4.11a.263.263 0 0 0 .318-.24v-.016l.001-.001v-5.141a.26.26 0 0 0-.254-.264M61.032 18.567h.297a.333.333 0 0 1-.254-.274l-.001-.006a.313.313 0 0 1 .004-.116c.308-1.878 1.929-3.839 4.725-3.839 3.084 0 4.497 1.876 4.738 3.831h-.002a.305.305 0 0 1 .007.05l.001.015c.001.02 0 .04-.002.059l-.001.005-.002.01a.335.335 0 0 1-.253.265l.285-.001h-9.542zm15.223 2.196c0-6.898-3.947-11.122-10.54-11.122-5.464 0-10.496 4.453-10.496 11.308 0 7.247 5.162 11.481 11.018 11.481 5.084 0 8.416-2.909 9.605-6.465a.03.03 0 0 0 .004-.01l.004-.01a.322.322 0 0 0-.206-.417h-.001v-.003l-4.211-1.258-.004-.002a.3.3 0 0 0-.099-.015.32.32 0 0 0-.293.193l-.002.003-.002.001c-.734 1.775-2.193 2.996-4.753 2.996-2.802 0-5.146-1.992-5.365-4.726a.335.335 0 0 1 .195-.175h14.759c.17 0 .31-.134.32-.305l.002-.001c.025-.342.065-.91.065-1.473zM80.714 31.554h4.227V10.79h-4.227v20.763zM82.805 0c1.727 0 3.091 1.295 3.091 2.935 0 1.597-1.364 2.892-3.09 2.892-1.683 0-3.045-1.295-3.045-2.892 0-1.64 1.362-2.935 3.044-2.935zM89.402 31.554V11.112h3.906v2.72c1.301-2.252 3.905-3.314 6.334-3.314 2.604 0 5.121 1.233 6.248 3.868 1.65-2.934 4.34-3.868 6.988-3.868 3.644 0 7.202 2.422 7.202 7.777v13.259h-4.035V18.72c0-2.677-1.346-4.674-4.427-4.674-2.863 0-4.816 2.209-4.816 5.141v12.367h-4.079V18.72c0-2.635-1.301-4.674-4.425-4.674-2.908 0-4.86 2.125-4.86 5.184v12.324h-4.036zM136.87 22.954v-.943l-6.24.943c-1.697.256-2.97 1.243-2.97 3.087 0 1.544 1.273 3.002 3.31 3.002 3.27 0 5.9-1.588 5.9-6.09m-7.088-2.958l5.518-.814c1.23-.173 1.57-.816 1.57-1.545 0-2.015-1.316-3.688-4.413-3.688-2.802 0-4.372 1.758-4.627 4.16l-3.82-.9c.424-3.946 3.947-6.69 8.362-6.69 6.111 0 8.488 3.516 8.488 7.547V28.4c0 1.801.17 2.873.256 3.388h-3.907c-.085-.515-.21-1.287-.21-2.787-.892 1.458-2.93 3.43-6.58 3.43-4.16 0-6.833-2.915-6.833-6.175 0-3.688 2.673-5.746 6.196-6.26M160.862 20.551c0-3.987-2.439-6.603-5.965-6.603-3.613 0-6.052 2.616-6.052 6.603 0 4.031 2.35 6.605 6.052 6.605 3.526 0 5.965-2.617 5.965-6.605zm-12.279 11.193c.305 2.873 2.525 5.059 5.705 5.059 4.398 0 6.4-2.23 6.4-6.69v-2.957c-1.002 1.885-3.266 3.386-6.4 3.386-5.574 0-9.623-4.159-9.623-9.99 0-5.574 3.875-10.034 9.623-10.034 3.221 0 5.398 1.2 6.443 3.258v-2.872h4.05v19.08c0 5.233-2.613 10.335-10.493 10.335-5.226 0-9.145-3.259-9.666-7.675l3.961-.9zM169.241 31.554h4.228V10.79h-4.228v20.763zM171.333 0c1.726 0 3.09 1.295 3.09 2.935 0 1.597-1.364 2.892-3.09 2.892-1.683 0-3.046-1.295-3.046-2.892 0-1.64 1.363-2.935 3.046-2.935zM183.68 31.554h-3.999V11.112h3.914v2.934c1.49-2.55 3.915-3.528 6.298-3.528 4.893 0 7.318 3.528 7.318 8.074v12.962h-3.999V19.27c0-2.846-1.192-5.141-4.766-5.141-3.148 0-4.766 2.508-4.766 5.61v11.814zM216.59 19.352c-.087-2.959-2.054-5.275-5.771-5.275-3.455 0-5.554 2.616-5.728 5.275h11.5zm4.155 6.56c-1.18 3.645-4.548 6.518-9.445 6.518-5.642 0-10.583-4.032-10.583-11.02 0-6.475 4.767-10.892 10.058-10.892 6.472 0 10.101 4.374 10.101 10.807 0 .514-.044 1.028-.087 1.286h-15.831c.088 3.687 2.8 6.26 6.342 6.26 3.41 0 5.116-1.845 5.903-4.16l3.542 1.202z",
                                              fill: "#FEFEFE",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-full md:w-1/2 md:text-right mt-2 md:mt-0",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "216px",
                                      height: "19px",
                                      viewBox: "0 0 216 19",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                    },
                                  },
                                  [
                                    _c("title", [_vm._v("CollaboratorPortal")]),
                                    _vm._v(" "),
                                    _c(
                                      "defs",
                                      [
                                        _c(
                                          "linearGradient",
                                          {
                                            attrs: {
                                              x1: "15.5147059%",
                                              y1: "50%",
                                              x2: "100%",
                                              y2: "50%",
                                              id: "linearGradient-1",
                                            },
                                          },
                                          [
                                            _c("stop", {
                                              attrs: {
                                                "stop-color": "#F6DCC3",
                                                offset: "0%",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("stop", {
                                              attrs: {
                                                "stop-color": "#E1C3D0",
                                                offset: "100%",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Sample-Page-Designs",
                                          stroke: "none",
                                          "stroke-width": "1",
                                          fill: "none",
                                          "fill-rule": "evenodd",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "Admin_Example-",
                                              transform:
                                                "translate(-1092.000000, -83.000000)",
                                              fill: "url(#linearGradient-1)",
                                              "fill-rule": "nonzero",
                                            },
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "Masthead-A",
                                                  transform:
                                                    "translate(130.000000, 32.000000)",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M971.128,69.36 C975.472,69.36 978.064,66.6 978.832,63.72 L976.192,62.856 C975.616,64.776 973.984,66.6 971.128,66.6 C968.224,66.6 965.488,64.488 965.488,60.504 C965.488,56.376 968.296,54.336 971.104,54.336 C973.96,54.336 975.544,55.992 976.048,58.056 L978.76,57.144 C977.992,54.168 975.424,51.624 971.104,51.624 C966.688,51.624 962.536,54.96 962.536,60.504 C962.536,66.048 966.544,69.36 971.128,69.36 Z M986.656,69.36 C990.16,69.36 992.728,66.744 992.728,63.144 C992.728,59.568 990.16,56.952 986.656,56.952 C983.176,56.952 980.608,59.568 980.608,63.144 C980.608,66.744 983.176,69.36 986.656,69.36 Z M986.656,66.864 C984.952,66.864 983.392,65.568 983.392,63.144 C983.392,60.72 984.952,59.472 986.656,59.472 C988.384,59.472 989.92,60.72 989.92,63.144 C989.92,65.592 988.384,66.864 986.656,66.864 Z M998.632,69 L998.632,51.624 L995.848,51.624 L995.848,69 L998.632,69 Z M1005.448,69 L1005.448,51.624 L1002.664,51.624 L1002.664,69 L1005.448,69 Z M1012.672,69.36 C1014.568,69.36 1015.72,68.4 1016.272,67.512 C1016.272,68.448 1016.368,68.928 1016.392,69 L1018.984,69 C1018.96,68.88 1018.84,68.184 1018.84,67.128 L1018.84,61.32 C1018.84,58.992 1017.472,56.952 1013.872,56.952 C1010.992,56.952 1009.168,58.752 1008.952,60.768 L1011.496,61.344 C1011.616,60.168 1012.432,59.232 1013.896,59.232 C1015.432,59.232 1016.104,60.024 1016.104,61.008 C1016.104,61.416 1015.912,61.752 1015.24,61.848 L1012.24,62.304 C1010.248,62.592 1008.712,63.744 1008.712,65.832 C1008.712,67.68 1010.224,69.36 1012.672,69.36 Z M1013.2,67.176 C1012.096,67.176 1011.496,66.456 1011.496,65.664 C1011.496,64.704 1012.192,64.224 1013.056,64.08 L1016.104,63.624 L1016.104,64.152 C1016.104,66.432 1014.76,67.176 1013.2,67.176 Z M1028.944,69.288 C1032.352,69.288 1034.44,66.624 1034.44,63.096 C1034.44,59.664 1032.544,57 1029.04,57 C1027.24,57 1025.896,57.84 1025.368,58.752 L1025.368,51.624 L1022.632,51.624 L1022.632,69 L1025.344,69 L1025.344,67.44 C1026.016,68.568 1027.288,69.288 1028.944,69.288 Z M1028.488,66.816 C1026.712,66.816 1025.344,65.424 1025.344,63.12 C1025.344,60.792 1026.712,59.472 1028.488,59.472 C1030.336,59.472 1031.632,60.792 1031.632,63.12 C1031.632,65.424 1030.312,66.816 1028.488,66.816 Z M1042.696,69.36 C1046.2,69.36 1048.768,66.744 1048.768,63.144 C1048.768,59.568 1046.2,56.952 1042.696,56.952 C1039.216,56.952 1036.648,59.568 1036.648,63.144 C1036.648,66.744 1039.216,69.36 1042.696,69.36 Z M1042.696,66.864 C1040.992,66.864 1039.432,65.568 1039.432,63.144 C1039.432,60.72 1040.992,59.472 1042.696,59.472 C1044.424,59.472 1045.96,60.72 1045.96,63.144 C1045.96,65.592 1044.424,66.864 1042.696,66.864 Z M1054.672,69 L1054.672,63.432 C1054.672,61.248 1055.656,60 1057.816,60 C1058.104,60 1058.416,60.024 1058.728,60.072 L1058.728,57.24 C1058.608,57.216 1058.32,57.168 1057.984,57.168 C1056.448,57.168 1055.152,57.912 1054.6,59.184 L1054.6,57.312 L1051.888,57.312 L1051.888,69 L1054.672,69 Z M1064.752,69.36 C1066.648,69.36 1067.8,68.4 1068.352,67.512 C1068.352,68.448 1068.448,68.928 1068.472,69 L1071.064,69 C1071.04,68.88 1070.92,68.184 1070.92,67.128 L1070.92,61.32 C1070.92,58.992 1069.552,56.952 1065.952,56.952 C1063.072,56.952 1061.248,58.752 1061.032,60.768 L1063.576,61.344 C1063.696,60.168 1064.512,59.232 1065.976,59.232 C1067.512,59.232 1068.184,60.024 1068.184,61.008 C1068.184,61.416 1067.992,61.752 1067.32,61.848 L1064.32,62.304 C1062.328,62.592 1060.792,63.744 1060.792,65.832 C1060.792,67.68 1062.304,69.36 1064.752,69.36 Z M1065.28,67.176 C1064.176,67.176 1063.576,66.456 1063.576,65.664 C1063.576,64.704 1064.272,64.224 1065.136,64.08 L1068.184,63.624 L1068.184,64.152 C1068.184,66.432 1066.84,67.176 1065.28,67.176 Z M1078.936,69.144 C1079.944,69.144 1080.472,68.952 1080.64,68.88 L1080.64,66.576 C1080.52,66.6 1080.064,66.672 1079.68,66.672 C1078.648,66.672 1078.192,66.24 1078.192,65.208 L1078.192,59.784 L1080.616,59.784 L1080.616,57.312 L1078.192,57.312 L1078.192,53.736 L1075.672,53.736 L1075.672,55.488 C1075.672,56.52 1075.12,57.312 1073.872,57.312 L1073.272,57.312 L1073.272,59.784 L1075.432,59.784 L1075.432,65.664 C1075.432,67.848 1076.776,69.144 1078.936,69.144 Z M1088.92,69.36 C1092.424,69.36 1094.992,66.744 1094.992,63.144 C1094.992,59.568 1092.424,56.952 1088.92,56.952 C1085.44,56.952 1082.872,59.568 1082.872,63.144 C1082.872,66.744 1085.44,69.36 1088.92,69.36 Z M1088.92,66.864 C1087.216,66.864 1085.656,65.568 1085.656,63.144 C1085.656,60.72 1087.216,59.472 1088.92,59.472 C1090.648,59.472 1092.184,60.72 1092.184,63.144 C1092.184,65.592 1090.648,66.864 1088.92,66.864 Z M1100.896,69 L1100.896,63.432 C1100.896,61.248 1101.88,60 1104.04,60 C1104.328,60 1104.64,60.024 1104.952,60.072 L1104.952,57.24 C1104.832,57.216 1104.544,57.168 1104.208,57.168 C1102.672,57.168 1101.376,57.912 1100.824,59.184 L1100.824,57.312 L1098.112,57.312 L1098.112,69 L1100.896,69 Z M1117.168,69 L1117.168,62.352 L1120.6,62.352 C1123.864,62.352 1126.024,60.168 1126.024,57.168 C1126.024,54.192 1123.864,51.984 1120.6,51.984 L1114.288,51.984 L1114.288,69 L1117.168,69 Z M1120.168,59.808 L1117.168,59.808 L1117.168,54.528 L1120.168,54.528 C1121.992,54.528 1123.096,55.56 1123.096,57.192 C1123.096,58.8 1121.992,59.808 1120.168,59.808 Z M1133.224,69.36 C1136.728,69.36 1139.296,66.744 1139.296,63.144 C1139.296,59.568 1136.728,56.952 1133.224,56.952 C1129.744,56.952 1127.176,59.568 1127.176,63.144 C1127.176,66.744 1129.744,69.36 1133.224,69.36 Z M1133.224,66.864 C1131.52,66.864 1129.96,65.568 1129.96,63.144 C1129.96,60.72 1131.52,59.472 1133.224,59.472 C1134.952,59.472 1136.488,60.72 1136.488,63.144 C1136.488,65.592 1134.952,66.864 1133.224,66.864 Z M1145.2,69 L1145.2,63.432 C1145.2,61.248 1146.184,60 1148.344,60 C1148.632,60 1148.944,60.024 1149.256,60.072 L1149.256,57.24 C1149.136,57.216 1148.848,57.168 1148.512,57.168 C1146.976,57.168 1145.68,57.912 1145.128,59.184 L1145.128,57.312 L1142.416,57.312 L1142.416,69 L1145.2,69 Z M1156.792,69.144 C1157.8,69.144 1158.328,68.952 1158.496,68.88 L1158.496,66.576 C1158.376,66.6 1157.92,66.672 1157.536,66.672 C1156.504,66.672 1156.048,66.24 1156.048,65.208 L1156.048,59.784 L1158.472,59.784 L1158.472,57.312 L1156.048,57.312 L1156.048,53.736 L1153.528,53.736 L1153.528,55.488 C1153.528,56.52 1152.976,57.312 1151.728,57.312 L1151.128,57.312 L1151.128,59.784 L1153.288,59.784 L1153.288,65.664 C1153.288,67.848 1154.632,69.144 1156.792,69.144 Z M1165.024,69.36 C1166.92,69.36 1168.072,68.4 1168.624,67.512 C1168.624,68.448 1168.72,68.928 1168.744,69 L1171.336,69 C1171.312,68.88 1171.192,68.184 1171.192,67.128 L1171.192,61.32 C1171.192,58.992 1169.824,56.952 1166.224,56.952 C1163.344,56.952 1161.52,58.752 1161.304,60.768 L1163.848,61.344 C1163.968,60.168 1164.784,59.232 1166.248,59.232 C1167.784,59.232 1168.456,60.024 1168.456,61.008 C1168.456,61.416 1168.264,61.752 1167.592,61.848 L1164.592,62.304 C1162.6,62.592 1161.064,63.744 1161.064,65.832 C1161.064,67.68 1162.576,69.36 1165.024,69.36 Z M1165.552,67.176 C1164.448,67.176 1163.848,66.456 1163.848,65.664 C1163.848,64.704 1164.544,64.224 1165.408,64.08 L1168.456,63.624 L1168.456,64.152 C1168.456,66.432 1167.112,67.176 1165.552,67.176 Z M1177.768,69 L1177.768,51.624 L1174.984,51.624 L1174.984,69 L1177.768,69 Z",
                                                    id: "CollaboratorPortal",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-wrap max-w-2xl m-auto px-5",
                          },
                          [
                            _vm.isLoggedIn
                              ? _c(
                                  "nav",
                                  {
                                    staticClass:
                                      "nav__main w-full border-gray-dark border-t",
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-reset flex flex-wrap",
                                      },
                                      [
                                        !_vm.user.isAdmin
                                          ? _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "text-sm md:text-xl",
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: { name: "home-page" },
                                                      exact: "",
                                                    },
                                                  },
                                                  [_vm._v("Profile")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.user.isAdmin
                                          ? _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "text-sm md:text-xl",
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: { name: "my-events" },
                                                      exact: "",
                                                    },
                                                  },
                                                  [_vm._v("Events")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isLoggedIn
                                          ? [
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: "/auth/register",
                                                      },
                                                    },
                                                    [_vm._v("Register")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: "/auth/login",
                                                      },
                                                    },
                                                    [_vm._v("Login")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isLoggedIn
                                          ? [
                                              _vm.user.isAdmin
                                                ? [
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "text-sm md:text-xl",
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: "/events",
                                                            },
                                                          },
                                                          [_vm._v("Events")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "text-sm md:text-xl",
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: "/users",
                                                            },
                                                          },
                                                          [_vm._v("Users")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "text-sm md:text-xl",
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: "/categories",
                                                            },
                                                          },
                                                          [_vm._v("Categories")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "text-sm md:text-xl",
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: "/festivals",
                                                            },
                                                          },
                                                          [_vm._v("Festivals")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "text-sm md:text-xl",
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: "/organizations",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Organizations"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: "/resources",
                                                      },
                                                    },
                                                    [_vm._v("Resources")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              !_vm.user.isAdmin
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "text-sm md:text-xl hidden",
                                                    },
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: "/organization",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Public Profile"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.isAdmin
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "text-sm md:text-xl",
                                                    },
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: "/admin",
                                                          },
                                                        },
                                                        [_vm._v("Admin")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: { to: "/profile" },
                                                    },
                                                    [_vm._v("Account")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: "/auth/logout",
                                                      },
                                                    },
                                                    [_vm._v("Logout")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-sm md:text-xl lg:flex lg:flex-1 lg:justify-end lg:-mr-10",
                                                },
                                                [
                                                  !_vm.user.isAdmin
                                                    ? _c("li", {}, [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href: "https://help.letsreimagine.org/hc/en-us/articles/360041667612-Start-Here",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Getting Started"
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.user.isAdmin
                                                    ? _c("li", {}, [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href: "https://help.letsreimagine.org",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Help Center"
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "home__masthead bg-cover bg-center text-white pt-10 pb-12 lg:h-420px h-auto",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-wrap items-center max-w-2xl m-auto px-5 mb-10",
                            },
                            [
                              _c("div", { staticClass: "mb-10" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "router-link-active font-light tracking-wide text-lg flex flex-col text-white no-underline",
                                    attrs: { href: "/" },
                                  },
                                  [_c("ReimaginePortalIcon")],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(0),
                        ]
                      ),
                    ]),
                _vm._v(" "),
                _c(
                  "main",
                  {
                    staticClass: "max-w-2xl m-auto py-4 md:py-16 px-5",
                    attrs: { id: "main" },
                  },
                  [
                    _vm.isLoggedIn ||
                    _vm.$route.path.indexOf("/auth") !== -1 ||
                    _vm.isSignaturePage ||
                    _vm.isContractDisplay
                      ? _c(
                          "div",
                          [
                            _vm.showLegal ? _c("event-requirements") : _vm._e(),
                            _vm._v(" "),
                            _c("router-view"),
                            _vm._v(" "),
                            _c("div", { attrs: { id: "credit-auth" } }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("footer", { staticClass: "bg-black text-gray-medium" }, [
                  _c(
                    "div",
                    { staticClass: "max-w-2xl m-auto px-5 pt-5 pb-20" },
                    [
                      _c("router-link", { attrs: { to: _vm.home } }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "221",
                              height: "43",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c("defs", [
                              _c("path", {
                                attrs: {
                                  id: "a",
                                  d: "M0 34.733h28.385V.003H0z",
                                },
                              }),
                            ]),
                            _c(
                              "g",
                              {
                                attrs: { fill: "none", "fill-rule": "evenodd" },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: { transform: "translate(0 7.888)" },
                                  },
                                  [
                                    _c(
                                      "mask",
                                      { attrs: { id: "b", fill: "#fff" } },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#a" },
                                        }),
                                      ]
                                    ),
                                    _c("path", {
                                      attrs: {
                                        d: "M21.67 25.793l-4.833 3.42.008-3.432 4.825.012zM3.502 3.523l18.885.043-8.193 5.736c-.481.337-.77.892-.77 1.487l-.027 11.47-9.937-.023.042-18.713zm13.373 8.169l8.038-5.63-.037 16.223-8.024-.018.023-10.575zm11.51-10.297A1.322 1.322 0 0 0 27.08.061L1.364.002A1.322 1.322 0 0 0 .05 1.332l-.05 23.08a1.322 1.322 0 0 0 1.306 1.334l12.083.028-.017 7.626a1.32 1.32 0 0 0 1.304 1.333c.267 0 .525-.082.747-.238l12.322-8.72c.36-.255.579-.676.58-1.124v-.092c.003-.028.01-.054.01-.083l.05-23.08z",
                                        fill: "#FEFEFE",
                                        mask: "url(#b)",
                                      },
                                    }),
                                  ]
                                ),
                                _c("path", {
                                  attrs: {
                                    d: "M53.212 10.57c-.019 0-.036 0-.055.004-.327-.03-.665-.056-1.032-.056-1.706 0-4.328.438-5.793 2.689v-.002a.183.183 0 0 1-.152.073.18.18 0 0 1-.179-.181l-.002.001v-2.149a.263.263 0 0 0-.262-.253H40.591a.263.263 0 0 0-.271.25l-.001.003v20.337l.003.003v.003a.26.26 0 0 0 .324.255h5.24a.263.263 0 0 0 .326-.246l-.002-.024v-9.254c0-4.5 2.552-5.9 5.537-5.9.436 0 .896.028 1.4.11a.263.263 0 0 0 .318-.24v-.016l.001-.001v-5.141a.26.26 0 0 0-.254-.264M61.032 18.567h.297a.333.333 0 0 1-.254-.274l-.001-.006a.313.313 0 0 1 .004-.116c.308-1.878 1.929-3.839 4.725-3.839 3.084 0 4.497 1.876 4.738 3.831h-.002a.305.305 0 0 1 .007.05l.001.015c.001.02 0 .04-.002.059l-.001.005-.002.01a.335.335 0 0 1-.253.265l.285-.001h-9.542zm15.223 2.196c0-6.898-3.947-11.122-10.54-11.122-5.464 0-10.496 4.453-10.496 11.308 0 7.247 5.162 11.481 11.018 11.481 5.084 0 8.416-2.909 9.605-6.465a.03.03 0 0 0 .004-.01l.004-.01a.322.322 0 0 0-.206-.417h-.001v-.003l-4.211-1.258-.004-.002a.3.3 0 0 0-.099-.015.32.32 0 0 0-.293.193l-.002.003-.002.001c-.734 1.775-2.193 2.996-4.753 2.996-2.802 0-5.146-1.992-5.365-4.726a.335.335 0 0 1 .195-.175h14.759c.17 0 .31-.134.32-.305l.002-.001c.025-.342.065-.91.065-1.473zM80.714 31.554h4.227V10.79h-4.227v20.763zM82.805 0c1.727 0 3.091 1.295 3.091 2.935 0 1.597-1.364 2.892-3.09 2.892-1.683 0-3.045-1.295-3.045-2.892 0-1.64 1.362-2.935 3.044-2.935zM89.402 31.554V11.112h3.906v2.72c1.301-2.252 3.905-3.314 6.334-3.314 2.604 0 5.121 1.233 6.248 3.868 1.65-2.934 4.34-3.868 6.988-3.868 3.644 0 7.202 2.422 7.202 7.777v13.259h-4.035V18.72c0-2.677-1.346-4.674-4.427-4.674-2.863 0-4.816 2.209-4.816 5.141v12.367h-4.079V18.72c0-2.635-1.301-4.674-4.425-4.674-2.908 0-4.86 2.125-4.86 5.184v12.324h-4.036zM136.87 22.954v-.943l-6.24.943c-1.697.256-2.97 1.243-2.97 3.087 0 1.544 1.273 3.002 3.31 3.002 3.27 0 5.9-1.588 5.9-6.09m-7.088-2.958l5.518-.814c1.23-.173 1.57-.816 1.57-1.545 0-2.015-1.316-3.688-4.413-3.688-2.802 0-4.372 1.758-4.627 4.16l-3.82-.9c.424-3.946 3.947-6.69 8.362-6.69 6.111 0 8.488 3.516 8.488 7.547V28.4c0 1.801.17 2.873.256 3.388h-3.907c-.085-.515-.21-1.287-.21-2.787-.892 1.458-2.93 3.43-6.58 3.43-4.16 0-6.833-2.915-6.833-6.175 0-3.688 2.673-5.746 6.196-6.26M160.862 20.551c0-3.987-2.439-6.603-5.965-6.603-3.613 0-6.052 2.616-6.052 6.603 0 4.031 2.35 6.605 6.052 6.605 3.526 0 5.965-2.617 5.965-6.605zm-12.279 11.193c.305 2.873 2.525 5.059 5.705 5.059 4.398 0 6.4-2.23 6.4-6.69v-2.957c-1.002 1.885-3.266 3.386-6.4 3.386-5.574 0-9.623-4.159-9.623-9.99 0-5.574 3.875-10.034 9.623-10.034 3.221 0 5.398 1.2 6.443 3.258v-2.872h4.05v19.08c0 5.233-2.613 10.335-10.493 10.335-5.226 0-9.145-3.259-9.666-7.675l3.961-.9zM169.241 31.554h4.228V10.79h-4.228v20.763zM171.333 0c1.726 0 3.09 1.295 3.09 2.935 0 1.597-1.364 2.892-3.09 2.892-1.683 0-3.046-1.295-3.046-2.892 0-1.64 1.363-2.935 3.046-2.935zM183.68 31.554h-3.999V11.112h3.914v2.934c1.49-2.55 3.915-3.528 6.298-3.528 4.893 0 7.318 3.528 7.318 8.074v12.962h-3.999V19.27c0-2.846-1.192-5.141-4.766-5.141-3.148 0-4.766 2.508-4.766 5.61v11.814zM216.59 19.352c-.087-2.959-2.054-5.275-5.771-5.275-3.455 0-5.554 2.616-5.728 5.275h11.5zm4.155 6.56c-1.18 3.645-4.548 6.518-9.445 6.518-5.642 0-10.583-4.032-10.583-11.02 0-6.475 4.767-10.892 10.058-10.892 6.472 0 10.101 4.374 10.101 10.807 0 .514-.044 1.028-.087 1.286h-15.831c.088 3.687 2.8 6.26 6.342 6.26 3.41 0 5.116-1.845 5.903-4.16l3.542 1.202z",
                                    fill: "#FEFEFE",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-wrap flex-col md:flex-row mt-5",
                        },
                        [
                          _c("div", { staticClass: "text-sm mr-10 mb-2" }, [
                            _vm._v(
                              "©" +
                                _vm._s(new Date().getFullYear()) +
                                " Reimagine"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm mb-2 text-gray-medium mr-10 no-underline hover:underline",
                              attrs: {
                                target: "_blank",
                                href: "https://www.letsreimagine.org/privacy-cookies/",
                              },
                            },
                            [_vm._v("Privacy & Cookies")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-sm mb-2 text-gray-medium no-underline hover:underline",
                              attrs: {
                                target: "_blank",
                                href: "https://www.letsreimagine.org/terms-conditions/",
                              },
                            },
                            [_vm._v("Terms & Conditions")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-col max-w-2xl m-auto px-5" }, [
      _c("div", { staticClass: "w-full md:w-4/5" }, [
        _c("h1", { staticClass: "mb-3 text-4.5xl md:text-5xl leading-tight" }, [
          _vm._v("Welcome to the "),
          _c("br"),
          _vm._v("Reimagine Collaborator Portal"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }